module.exports = __webpack_public_path__ + "static/img/PR.8ad770ae.png";